import React from 'react';
import { Helmet } from 'react-helmet-async';
export function SEO() {
  const title = 'Code 11 Weddings Hvar | Luxury Wedding Venue in Hvar, Croatia';
  const description = 'Plan your dream wedding at Code 11 Restaurant in Hvar, Croatia. Exclusive Mediterranean wedding venue offering Diamond Premium packages, gourmet cuisine, and breathtaking Adriatic coast settings.';
  const keywords = 'weddings hvar, wedding venue hvar croatia, luxury wedding croatia, destination wedding hvar, mediterranean wedding, code 11 weddings, hvar wedding restaurant, adriatic wedding venue, diamond premium booking, wedding planning croatia';
  const url = 'https://code-11.hr/weddings/';
  const image = 'https://code-11.hr/wp-content/uploads/2025/05/2G6A8588-scaled.jpg';
  const structuredData = {
    '@context': 'https://schema.org',
    '@type': 'WeddingVenue',
    name: 'Code 11 Restaurant - Weddings',
    description: description,
    url: url,
    image: image,
    telephone: '+385912911466',
    email: 'info@code-11.hr',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Hvar',
      addressRegion: 'Split-Dalmatia County',
      addressCountry: 'HR'
    },
    geo: {
      '@type': 'GeoCoordinates',
      latitude: '43.1729',
      longitude: '16.4412'
    },
    priceRange: '€€€',
    sameAs: ['https://www.instagram.com/code11hvar/'],
    offers: [{
      '@type': 'Offer',
      name: 'Silver Wedding Package',
      description: 'Up to 50 guests - Welcome cocktail, 3-course dinner, basic décor, 5-hour venue rental',
      price: '3500',
      priceCurrency: 'EUR'
    }, {
      '@type': 'Offer',
      name: 'Gold Wedding Package',
      description: 'Up to 100 guests - Premium cocktail hour, 5-course dinner, enhanced décor, DJ, 8-hour venue rental',
      price: '7500',
      priceCurrency: 'EUR'
    }, {
      '@type': 'Offer',
      name: 'Diamond Premium Wedding Package',
      description: 'Up to 150 guests - Full premium experience, 7-course tasting menu, luxury décor, live band, full-day venue rental, wedding coordinator, complimentary bridal suite',
      price: '12500',
      priceCurrency: 'EUR'
    }]
  };
  return <Helmet data-id="element-157">
      {/* Primary Meta Tags */}
      <title data-id="element-158">{title}</title>
      <meta name="title" content={title} data-id="element-159" />
      <meta name="description" content={description} data-id="element-160" />
      <meta name="keywords" content={keywords} data-id="element-161" />
      <meta name="robots" content="index, follow" data-id="element-162" />
      <meta name="language" content="English" data-id="element-163" />
      <meta name="author" content="Code 11 Restaurant" data-id="element-164" />
      <link rel="canonical" href={url} data-id="element-165" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" data-id="element-166" />
      <meta property="og:url" content={url} data-id="element-167" />
      <meta property="og:title" content={title} data-id="element-168" />
      <meta property="og:description" content={description} data-id="element-169" />
      <meta property="og:image" content={image} data-id="element-170" />
      <meta property="og:locale" content="en_US" data-id="element-171" />
      <meta property="og:site_name" content="Code 11 Weddings Hvar" data-id="element-172" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" data-id="element-173" />
      <meta name="twitter:url" content={url} data-id="element-174" />
      <meta name="twitter:title" content={title} data-id="element-175" />
      <meta name="twitter:description" content={description} data-id="element-176" />
      <meta name="twitter:image" content={image} data-id="element-177" />

      {/* Structured Data */}
      <script type="application/ld+json" data-id="element-178">
        {JSON.stringify(structuredData)}
      </script>
    </Helmet>;
}